export default "__VITE_ASSET__D2k_WE8R__"